import {ChangeDetectionStrategy, Component, Input} from "@angular/core";
import {VisitScheduleOverviewReportModel} from "../../../models/visit-schedule-overview.model";
import {
  REPORTS_TABLE_COLUMN_WIDTHS,
  REPORTS_TABLE_ROW_HEIGHT,
  REPORTS_TABLE_UNIQUE_ID
} from "../../../constants/reports-table-column-widths.constant";

require('./scheduling-project-reports-table.scss');
@Component({
  standalone: false,
  selector: 'app-scheduling-project-reports-table',
  templateUrl: './scheduling-project-reports-table.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SchedulingProjectReportsTableComponent {

  @Input() reports: VisitScheduleOverviewReportModel[] = [];

  public readonly tableUniqueId: string = REPORTS_TABLE_UNIQUE_ID;
  public readonly defaultWidths: { [key: string]: number } = REPORTS_TABLE_COLUMN_WIDTHS;
  public readonly rowHeight: number = REPORTS_TABLE_ROW_HEIGHT;

}
